import React from 'react';

import { Alert, AlertTitle } from '@mui/material';

import FormCard from '../components/FormCard';
import FormListContainer from '../components/FormListContainer';

import { useAppData } from '../core/context/AppDataContext';

import LoadingOverlay from '../components/LoadingOverlay';

function Home() {
  const { authorizedForms } = useAppData();

  if (authorizedForms !== undefined) {
    if (authorizedForms.length === 0) {
      return (
        <Alert severity="warning">
          <AlertTitle>Warning - Unauthorized</AlertTitle>
          You are not authorized to View or Edit any forms - Please contact Helpdesk
        </Alert>
      );
    }

    return (
      <React.Fragment>
        {authorizedForms.map((authorizedForm) => {
          if (authorizedForm.metadata) {
            return (
              <FormCard
                key={authorizedForm.metadata.id}
                color={authorizedForm.metadata.color}
                title={authorizedForm.metadata.reportType}
                rootRoute={authorizedForm.metadata.route}
                // eslint-disable-next-line max-len
                disableNew={!authorizedForm.isContributor}
              >
                <FormListContainer formMetadata={authorizedForm.metadata} />
              </FormCard>
            );
          }

          return null;
        })}
      </React.Fragment>
    );
  }

  return (
    <LoadingOverlay />
  );
}

export default Home;
